// @flow
// Export user info preloaded from base.html.

import _ from 'lodash';

import type { Field } from 'app/common/utils/DeveloperUtils';

type PreloadData = {
  service?: {
    key?: string,
    title?: string,
    meta?: {
      human_readable_key?: string,
      oauth?: boolean,
      oauth_302_url?: string,
    },
    upfront_fields?: Array<Field>,
  },
};

type PreloadItems = {
  apiImage: ?string,
  apiTitle: ?string,
  selectedApi: ?string,
  isOauth: ?boolean,
  oauthUrl: ?string,
  upfrontFields: ?Array<Field>,
};

const preload: PreloadData = window.preload || {};

export default preload;

const servicePath = ['service'];
const serviceItem = kp => _.get(window.preload, [...servicePath, ...kp]);

export const preloadItems: PreloadItems = {
  apiImage: serviceItem(['key']),
  apiTitle: serviceItem(['title']),
  selectedApi: serviceItem(['meta', 'human_readable_key']),
  isOauth: serviceItem(['meta', 'oauth']),
  oauthUrl: serviceItem(['meta', 'oauth_302_url']),
  upfrontFields: serviceItem(['upfront_fields']),
};
